/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Accordion from '../components/sitecore/Accordion';
import AccordionSection from '../components/sitecore/AccordionSection';
import AlternativeLocation from '../components/sitecore/AlternativeLocation';
import Amenities from '../components/sitecore/Amenities';
import BookTour from '../components/sitecore/BookTour';
import ContactAndMap from '../components/sitecore/ContactAndMap';
import ContactLineNumber from '../components/sitecore/ContactLineNumber';
import CookiePolicyBanner from '../components/sitecore/CookiePolicyBanner';
import CTAModule from '../components/sitecore/CTAModule';
import DownloadCard from '../components/sitecore/DownloadCard';
import Downloads from '../components/sitecore/Downloads';
import Enquiry from '../components/sitecore/Enquiry';
import EnquiryModal from '../components/sitecore/EnquiryModal';
import Error from '../components/sitecore/Error';
import Footer from '../components/sitecore/Footer';
import GeosolutionHeader from '../components/sitecore/GeosolutionHeader';
import GetAQuote from '../components/sitecore/GetAQuote';
import HeroBasic from '../components/sitecore/HeroBasic';
import HeroContainer from '../components/sitecore/HeroContainer';
import HeroFull from '../components/sitecore/HeroFull';
import HighlightText from '../components/sitecore/HighlightText';
import HomepageHero from '../components/sitecore/HomepageHero';
import HomepageSearch from '../components/sitecore/HomepageSearch';
import HtmlSitemap from '../components/sitecore/HtmlSitemap';
import Image from '../components/sitecore/Image';
import ImageAndDescriptionWithItemList from '../components/sitecore/ImageAndDescriptionWithItemList';
import ImageWithTitleAndDescription from '../components/sitecore/ImageWithTitleAndDescription';
import InlineForm from '../components/sitecore/InlineForm';
import KeyFeatures from '../components/sitecore/KeyFeatures';
import LanguageSelector from '../components/sitecore/LanguageSelector';
import LanguageSelectorModal from '../components/sitecore/LanguageSelectorModal';
import LayoutSticky from '../components/sitecore/LayoutSticky';
import LocationHeader from '../components/sitecore/LocationHeader';
import MetaTags from '../components/sitecore/MetaTags';
import NavBar from '../components/sitecore/NavBar';
import PopularInThisArea from '../components/sitecore/PopularInThisArea';
import Promo from '../components/sitecore/Promo';
import Quote from '../components/sitecore/Quote';
import QuoteAndStories from '../components/sitecore/QuoteAndStories';
import RegusTabs from '../components/sitecore/RegusTabs';
import RelatedArticles from '../components/sitecore/RelatedArticles';
import ResultsCards from '../components/sitecore/ResultsCards';
import RichFiltering from '../components/sitecore/RichFiltering';
import SolutionBuilder from '../components/sitecore/SolutionBuilder';
import SolutionBuilderNav from '../components/sitecore/SolutionBuilderNav';
import SolutionBuilderResults from '../components/sitecore/SolutionBuilderResults';
import SolutionFAQ from '../components/sitecore/SolutionFAQ';
import SolutionHero from '../components/sitecore/SolutionHero';
import SolutionsCards from '../components/sitecore/SolutionsCards';
import SolutionsInTheArea from '../components/sitecore/SolutionsInTheArea';
import SolutionTabs from '../components/sitecore/SolutionTabs';
import StickyBar from '../components/sitecore/StickyBar';
import StickyBarPhoneNumber from '../components/sitecore/StickyBarPhoneNumber';
import TextAndCTA from '../components/sitecore/TextAndCTA';
import TextAndList from '../components/sitecore/TextAndList';
import TextBlock from '../components/sitecore/TextBlock';
import ThankYouForm from '../components/sitecore/ThankYouForm';
import Webchat from '../components/sitecore/Webchat';
import Wildcards from '../components/sitecore/Wildcards';
import WorkspaceEditor from '../components/sitecore/WorkspaceEditor';

const components = new Map();
components.set('Accordion', Accordion);
components.set('AccordionSection', AccordionSection);
components.set('AlternativeLocation', AlternativeLocation);
components.set('Amenities', Amenities);
components.set('BookTour', BookTour);
components.set('ContactAndMap', ContactAndMap);
components.set('ContactLineNumber', ContactLineNumber);
components.set('CookiePolicyBanner', CookiePolicyBanner);
components.set('CTAModule', CTAModule);
components.set('DownloadCard', DownloadCard);
components.set('Downloads', Downloads);
components.set('Enquiry', Enquiry);
components.set('EnquiryModal', EnquiryModal);
components.set('Error', Error);
components.set('Footer', Footer);
components.set('GeosolutionHeader', GeosolutionHeader);
components.set('GetAQuote', GetAQuote);
components.set('HeroBasic', HeroBasic);
components.set('HeroContainer', HeroContainer);
components.set('HeroFull', HeroFull);
components.set('HighlightText', HighlightText);
components.set('HomepageHero', HomepageHero);
components.set('HomepageSearch', HomepageSearch);
components.set('HtmlSitemap', HtmlSitemap);
components.set('Image', Image);
components.set('ImageAndDescriptionWithItemList', ImageAndDescriptionWithItemList);
components.set('ImageWithTitleAndDescription', ImageWithTitleAndDescription);
components.set('InlineForm', InlineForm);
components.set('KeyFeatures', KeyFeatures);
components.set('LanguageSelector', LanguageSelector);
components.set('LanguageSelectorModal', LanguageSelectorModal);
components.set('LayoutSticky', LayoutSticky);
components.set('LocationHeader', LocationHeader);
components.set('MetaTags', MetaTags);
components.set('NavBar', NavBar);
components.set('PopularInThisArea', PopularInThisArea);
components.set('Promo', Promo);
components.set('Quote', Quote);
components.set('QuoteAndStories', QuoteAndStories);
components.set('RegusTabs', RegusTabs);
components.set('RelatedArticles', RelatedArticles);
components.set('ResultsCards', ResultsCards);
components.set('RichFiltering', RichFiltering);
components.set('SolutionBuilder', SolutionBuilder);
components.set('SolutionBuilderNav', SolutionBuilderNav);
components.set('SolutionBuilderResults', SolutionBuilderResults);
components.set('SolutionFAQ', SolutionFAQ);
components.set('SolutionHero', SolutionHero);
components.set('SolutionsCards', SolutionsCards);
components.set('SolutionsInTheArea', SolutionsInTheArea);
components.set('SolutionTabs', SolutionTabs);
components.set('StickyBar', StickyBar);
components.set('StickyBarPhoneNumber', StickyBarPhoneNumber);
components.set('TextAndCTA', TextAndCTA);
components.set('TextAndList', TextAndList);
components.set('TextBlock', TextBlock);
components.set('ThankYouForm', ThankYouForm);
components.set('Webchat', Webchat);
components.set('Wildcards', Wildcards);
components.set('WorkspaceEditor', WorkspaceEditor);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
